import PayPalLogo from 'src/assets/images/new-plan-paywall/paypal.svg';
import AmexLogo from 'src/assets/images/payment/amex-logo.svg';
import MasterCardLogo from 'src/assets/images/payment/mastercard-logo.svg';
import UnionPayLogo from 'src/assets/images/payment/unionpay-logo.svg';
import VisaLogo from 'src/assets/images/payment/visa-logo.svg';

import styles from './debit-credit-block.module.scss';

export const DebitCreditBlock = () => (
  <div className={styles.debitCreditBlock}>
    <p>Debit / credit card</p>
    <figure className={styles.logosContainer}>
      <VisaLogo className={styles.visaLogo} />
      <MasterCardLogo className={styles.mastercardLogo} />
      <PayPalLogo className={styles.paypalLogo} />
      <AmexLogo className={styles.amexLogo} />
      <UnionPayLogo className={styles.unionpayLogo} />
    </figure>
  </div>
);
